import * as vp from 'vopay';
import { FunctionComponent, useEffect } from 'react';

import { Link } from 'react-router-dom';
import { useLayout } from '../../../providers/Layout.provider';
import { useToken } from '../../../providers/Token.provider';

const { Box, Title, Button, Term } = vp;

type FC = FunctionComponent;

const ProfileOptions: FC = () => {
  const { color, setLayoutInfo } = useLayout();
  const { token } = useToken();
  useEffect(() => {
    setLayoutInfo(
      vp.chooseColor<string | null | undefined>('#FFD147', token?.BrandingDetails?.Branding?.PrimaryColor),
      'moon',
      '',
      80,
      20,
      0,
      true,
      false,
    );
  }, []);

  return (
    <Box jc="center">
      <Box flx="col" ai="center" maxwidth="475px">
        <Title title="What is Your Account Type?" size="lg" bold />

        <Box flx="col" gap="md" pt="lg" pb="md" width="100%">
          <Link to={{ pathname: '/create-personal-profile' }}>
            <Button
              id="account-type-personal"
              label="Personal"
              width="100%"
              round
              color="none"
              textColor={vp.getContrastColor(color)}
              size="xlg"
              textSize={1}
              icon="personal"
              iconSize="md"
              iconLocation="start"
              background={color}
            />
          </Link>

          <Link to={{ pathname: '/create-business-profile' }}>
            <Button
              id="account-type-personal"
              label="Business"
              width="100%"
              round
              color="none"
              textColor={vp.getContrastColor(color)}
              size="xlg"
              textSize={1}
              icon="business"
              iconSize="md"
              iconLocation="start"
              background={color}
            />
          </Link>
        </Box>

        <Term term="This is a secure page and your information will be encrypted. No bank accout login details will be saved." />
      </Box>
    </Box>
  );
};

export default ProfileOptions;
